module.exports = __webpack_public_path__ + "static/media/nuclear.dc1d058a.svg";